export default {
  'software.poweredBy': 'Alimenté par',
  'copyright': 'Droits d\'Auteur',
  'allRightsReserved': 'Tous les droits sont réservés',
};